import { useState, useEffect, useCallback, memo } from "react";
import Swal from "sweetalert2";
import AnimacionCarga from "../animacion_de_carga";
import TablaGenerica from "../tablas";
import BotonFlotante from "../BotonFlotante";
import { consultarSimple } from "../../../functions/crud";

const columnas = [
  { label: "ID",             key: "idLog" },
  { label: "Fecha",          key: "fecha" },
  { label: "Usuario",        key: "usuario" },
  { label: "Código Cliente", key: "codigoCliente" },
  { label: "Permisos",       key: "permisos" },
  { label: "Acción",         key: "accion" },
  { label: "URL",            key: "url" },
  { label: "Dispositivo",    key: "dispositivo" },
  { label: "Versión",        key: "version" },
];

const obtenerLogs = async (fecha = new Date()) => {
  try {
    const clientes = await consultarSimple("/clientes");
    if (!clientes) return [];

    const año = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const dia = String(fecha.getDate()).padStart(2, "0");

    const resultados = [];

    await Promise.all(
      Object.keys(clientes).map(async (codigoCliente) => {
        const data = await consultarSimple(`/logs/${codigoCliente}/${año}/${mes}/${dia}`);
        if (!data) return;

        for (const [usuario, logs] of Object.entries(data)) {
          if (!logs) continue;
          for (const [idLog, detalles] of Object.entries(logs)) {
            if (!detalles) continue;
            if (typeof detalles.url !== "string" || !detalles.url.trim()) continue;

            resultados.push({
              codigoCliente, año, mes, dia, usuario, idLog,
              accion:      detalles.accion      || "",
              permisos:    detalles.permisos     || "",
              dispositivo: detalles.dispositivo  || "",
              version:     detalles.version      || "",
              fecha:       detalles.fecha        || "",
              url:         detalles.url.trim(),
            });
          }
        }
      })
    );

    return resultados;
  } catch (error) {
    console.error("Error al obtener logs:", error.message);
    return [];
  }
};

const hoyISO = () => new Date().toISOString().split("T")[0];

const ListadoLogs = memo(() => {
  const [datos,    setDatos]    = useState([]);
  const [cargando, setCargando] = useState(false);
  const [fechaISO, setFechaISO] = useState(hoyISO());

  const consultarConFecha = useCallback(async (iso) => {
    setCargando(true);
    try {
      const data = await obtenerLogs(new Date(`${iso}T00:00:00`));
      setDatos(Array.isArray(data) ? data : Object.values(data || {}));
      setFechaISO(iso);
    } catch {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron obtener los logs.", confirmButtonColor: "#d32f2f" });
    } finally {
      setCargando(false);
    }
  }, []);

  const abrirSwalFecha = useCallback(async (fechaInicial) => {
    const { value, isConfirmed } = await Swal.fire({
      title: '<span style="font-size:17px;font-weight:700;color:#222">¿Qué fecha deseas consultar?</span>',
      html: `
        <input
          id="swal-fecha"
          type="date"
          value="${fechaInicial}"
          max="${hoyISO()}"
          style="
            width:100%;padding:11px 14px;font-size:15px;
            border:1.5px solid #ddd;border-radius:8px;
            box-sizing:border-box;margin-top:4px;outline:none;
          "
          onfocus="this.style.borderColor='#d32f2f'"
          onblur="this.style.borderColor='#ddd'"
        />`,
      confirmButtonText: "Consultar",
      confirmButtonColor: "#d32f2f",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      allowOutsideClick: false,
      focusConfirm: false,
      preConfirm: () => {
        const val = document.getElementById("swal-fecha").value;
        if (!val) { Swal.showValidationMessage("Selecciona una fecha"); return false; }
        return val;
      },
    });

    if (isConfirmed && value) consultarConFecha(value);
  }, [consultarConFecha]);

  useEffect(() => {
    abrirSwalFecha(hoyISO());
  }, []);

  return (
    <div>
      {cargando ? (
        <AnimacionCarga />
      ) : (
        <>
          <TablaGenerica
            datos={datos}
            titulos={columnas.map(c => c.label)}
            campos={columnas.map(c => c.key)}
            elementosPorPagina={200}
          />

          <BotonFlotante
            opciones={[
              { texto: "Cambiar fecha", icono: "📅", accion: () => abrirSwalFecha(fechaISO) },
              { texto: "Refrescar",     icono: "🔄", accion: () => consultarConFecha(fechaISO) },
            ]}
            data={datos}
            headers={columnas}
            nombreArchivo="listado_logs"
          />
        </>
      )}
    </div>
  );
});

export default ListadoLogs;